import { createRouter, createWebHistory } from 'vue-router';
import {useStore} from "vuex";
import axios from "axios";
import {refreshAccessToken, verifyToken} from "@/services/tokenService";

import ContentView from "@/views/ContentView.vue";
import ClientsListView from "@/views/ClientsListView.vue";
import RequestsListView from "@/views/RequestsListView.vue";
import AnalyticsView from "@/views/AnalyticsView.vue";
import RequestDetailsView from "@/views/RequestDetailsView.vue";
import ClientInfoView from "@/views/ClientInfoView.vue";
import LoginView from "@/views/LoginView.vue";

import AdminView from "@/views/AdminView.vue";
import AddTypesAndKinds from "@/components/admin/AddTypesAndKinds.vue";
import AdminDashboard from "@/components/admin/AdminDashboard.vue";
import UserListView from "@/components/admin/UserListView.vue";
import AreasStreetsView from "@/components/admin/AreasStreetsView.vue";
import RequestCloseReasonsView from "@/components/admin/RequestCloseReasonsView.vue";
import ProfileView from "@/views/ProfileView.vue";
import RequestCountByStreet from "@/components/analytics/RequestCountByStreet.vue";
import RequestsActiveView from "@/views/RequestsActiveView.vue";
import RequestsFromLanding from "@/views/RequestsFromLanding.vue";
import FitterStatsDashboardView from "@/views/FitterStatsDashboardView.vue";
import RequestsDisconnectionsView from "@/views/RequestsDisconnectionsView.vue";
import RequestsRevisionView from "@/views/RequestsRevisionView.vue";


// Create the router
const router = createRouter({
    history: createWebHistory(process.env.BASE_URL),
    routes: [
        {
            path: '/',
            name: 'home',
            component: ContentView,
            meta: { requiresAuth: true },
            redirect: () => {
                return 'active_requests'
            },
            children: [
                {
                    path: 'clients',
                    name: 'clients',
                    component: ClientsListView,
                    // meta: { requiresAuth: true }
                },
                {
                    path: 'client',
                    name: 'client information',
                    component: ClientInfoView,
                    props: true,
                    // meta: { requiresAuth: true }
                },
                {
                    path: 'requests_dashboard',
                    name: 'requests_dashboard',
                    component: AnalyticsView,
                    meta: { requiresManagerOrEngineer: true },
                    // meta: { requiresAuth: true }
                },
                {
                    path:'fitters_dashboard',
                    name: 'fitters_dashboard',
                    component: FitterStatsDashboardView
                },
                {
                  path: 'requests',
                  name: 'requests',
                  redirect: 'all_requests'
                },
                {
                    path: 'all_requests',
                    name: 'all_requests',
                    component: RequestsListView,
                    // meta: { requiresAuth: true }
                },
                {
                    path: 'active_requests',
                    name: 'active requests',
                    component: RequestsActiveView,
                },
                {
                    path:'disconnection_requests',
                    name: 'disconnection_requests',
                    component: RequestsDisconnectionsView
                },
                {
                    path: 'requests_for_revision',
                    name: 'requests_for_revision',
                    component: RequestsRevisionView
                },
                {
                    path: 'request',
                    name: 'request details',
                    component: RequestDetailsView,
                    // meta: { requiresAuth: true }
                },
                {
                  path: 'profile',
                  name: 'profile',
                  component: ProfileView,
                },
                {
                  path: 'requests_from_landing',
                  name: 'requests_from_landing',
                  component: RequestsFromLanding,
                },
                {
                    path: 'admin',
                    name: 'admin',
                    component: AdminView,
                    meta: { requiresSuperuser: true },
                    redirect: () => {
                        return '/admin/admin_dashboard'
                    },
                    children: [
                        {
                            path: 'admin_dashboard',
                            name: 'admin_dashboard',
                            component: AdminDashboard,
                        },
                        {
                            path: 'request_types_and_kinds',
                            name: 'request types and kinds',
                            component: AddTypesAndKinds
                        },
                        {
                            path: 'users_list',
                            name: 'users list',
                            component: UserListView
                        },
                        {
                            path: 'areas_streets',
                            name: 'areas streets',
                            component: AreasStreetsView
                        },
                        {
                            path: 'request_close_reasons',
                            name: 'request close reasons',
                            component: RequestCloseReasonsView
                        }
                    ]
                }
            ]
        },
        {
            path: '/login',
            name: 'login',
            component: LoginView
        },
        {
            path: '/test',
            name: 'test',
            meta: { requiresAuth: true },
            component: RequestCountByStreet
        }
    ]
});

export async function checkTokens(auth_token, refresh_token, store) {
    if (auth_token && await verifyToken(auth_token)) {
        axios.defaults.headers.common['Authorization'] = `Bearer ${auth_token}`;
        return { status: 'verified', redirect: null };
    }

    if (refresh_token) {
        const newToken = await refreshAccessToken(refresh_token);
        if (newToken) {
            await store.dispatch('tokens/setAccess', newToken);
            axios.defaults.headers.common['Authorization'] = `Bearer ${newToken}`;
            return { status: 'refreshed', redirect: null };
        }
    }

    return { status: 'invalid', redirect: '/login' };
}

// Navigation guard
router.beforeEach(async (to, from, next) => {
    const store = useStore();
    // Check if route requires authentication
    if (to.matched.some(record => record.meta.requiresAuth)) {
        const authToken = store.getters['tokens/access'];
        const refreshToken = store.getters['tokens/refresh'];
        const tokenStatus = await checkTokens(authToken, refreshToken, store);

        if (tokenStatus.status === 'invalid') {
            return next('/login'); // Redirect to log in
        }
    }

    // Handle superuser privileges
    if (to.matched.some(record => record.meta.requiresSuperuser)) {
        // const isSuperuser = store.getters['profile/is_superuser'];
        const response =  await axios.get('/account')

        if (response.data.user.is_superuser === false) {
            alert("Недостаточно прав!")
            return next('active_requests');
        }
    }

    if (to.matched.some(record => record.meta.requiresManagerOrEngineer)){
        const response =  await axios.get('/account')
        // console.log(response.data)
        // console.log(!response.data.is_manager)
        // console.log(!response.data.is_engineer)
        // console.log(!response.data.is_manager && !response.data.is_engineer)
        if (!response.data.is_manager && !response.data.is_engineer) {
            alert("Недостаточно прав!")
            return next('active_requests');
        }
    }
    return next(); // Proceed to route
});
export default router;
